"use strict";

import Dom from "common/Dom";
var variantDescriptionDefault = $(".product-description").html();
export const updateVariantImage = function updateVariantImage($this) {
  var variantFeaturedMediaId = $($this)
    .find(":selected")
    .attr("data-variant-featured-media-id");
  var variantImage = $("[data-media-id='" + variantFeaturedMediaId + "']");
  var slideIndex = variantImage
    .closest(".slick-slide")
    .attr("data-slick-index");
  if (variantImage.length) {
    $(Dom.imageSlider).slick("slickGoTo", slideIndex, true);
  }
};
export const updateVariantSubheader = function updateVariantSubheader($this) {
  var variantSubheader = $($this).find(":selected").attr("data-subheader");
  var productSubheader = $(".product-header__title");
  productSubheader.text(variantSubheader);
};
export const updateVariantDescription = function updateVariantDescription(
  $this,
) {
  var variantDescription = $($this).find(":selected").attr("data-description");
  var productDescription = $(".product-description");
  if (variantDescription.length) {
    productDescription.empty();
    productDescription.html(variantDescription);
  } else {
    productDescription.empty();
    productDescription.html(variantDescriptionDefault);
  }
};
export const updatePrice = function updatePrice($this) {
  var variant = $($this).find(":selected"),
    price = variant.data("price"),
    comparePrice = variant.data("compare-price"),
    onSale = comparePrice !== "" && comparePrice !== 0;
  var domVariantPrice = $(Dom.variantPrice),
    domVariantComparePrice = $(Dom.variantComparePrice);
  domVariantPrice.text(moneyStr(price));
  if (onSale) {
    domVariantComparePrice.text(moneyStr(comparePrice));
    domVariantPrice.addClass("product-header__price--sale");
  } else {
    domVariantComparePrice.empty();
    domVariantPrice.removeClass("product-header__price--sale");
  }
};
var moneyStr = function moneyStr(value) {
  var str = String(parseFloat(value) / 100);
  str += str.indexOf(".") < 0 ? ".00" : "00";
  return "$" + str.substring(0, str.indexOf(".") + 3);
};
